import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import RevealLine from "./RevealLine";
import { WA } from "@/lib/links";

const ROWS = [
  {
    title: "Tables",
    note: "From ₹1.5L",
    numbers: [
      { label: "99913 11399", href: WA.tables1, testid: "wa-tables-1-button" },
      { label: "62904 52125", href: WA.tables2, testid: "wa-tables-2-button" },
    ],
  },
  {
    title: "Premium Lounge",
    note: "Elevated view · priority entry",
    numbers: [
      { label: "74007 77077", href: WA.lounge1, testid: "wa-lounge-1-button" },
      { label: "97760 39776", href: WA.lounge2, testid: "wa-lounge-2-button" },
    ],
  },
  {
    title: "Offline Tickets",
    note: "Physical ticket enquiries",
    numbers: [{ label: "86218 64687", href: WA.offline, testid: "wa-offline-button" }],
  },
];

const Tables = () => (
  <section id="tables" data-testid="tables-section" className="relative bg-burgundy/40 border-y border-bone/10 px-5 sm:px-10 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl">
      <RevealLine inView className="eyebrow">Tables &amp; Lounge</RevealLine>
      <h2 className="mt-5 font-display font-bold uppercase leading-[1.05] tracking-tight text-2xl sm:text-3xl lg:text-4xl text-bone">
        <RevealLine inView delay={0.1}>Revealed soon.</RevealLine>
        <RevealLine inView delay={0.2} className="text-coral">Enquiries open.</RevealLine>
      </h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="mt-6 max-w-md text-sand text-sm sm:text-base leading-relaxed"
        data-testid="tables-copy"
      >
        Message us on WhatsApp and we'll hold your spot while the details are finalised.
      </motion.p>

      <div className="mt-12 sm:mt-16 divide-y divide-bone/10 border-y border-bone/10">
        {ROWS.map((row, i) => (
          <motion.div
            key={row.title}
            data-testid={`enquiry-row-${row.title.toLowerCase().replace(/\s+/g, "-")}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="grid gap-5 py-7 sm:py-8 md:grid-cols-[1fr_auto] md:items-center md:gap-10"
          >
            <div>
              <h3 className="font-display font-bold uppercase text-base sm:text-lg text-bone">{row.title}</h3>
              <p className="mt-1.5 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-ash">{row.note}</p>
            </div>
            <div className={`grid gap-3 ${row.numbers.length > 1 ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
              {row.numbers.map((n) => (
                <a
                  key={n.href}
                  data-testid={n.testid}
                  href={n.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 border border-bone/25 px-4 py-3 font-mono text-xs sm:text-sm text-bone whitespace-nowrap hover:border-coral hover:text-coral transition-colors duration-300 md:min-w-[180px]"
                >
                  <MessageCircle size={14} className="shrink-0" />
                  {n.label}
                </a>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Tables;
